import './styles.scss';

import React, {PropsWithChildren, ReactNode} from 'react';

export const AppStripeTable = ({children, ...rest}: PropsWithChildren) => {
    return (
        <div className='app-stripe-table' {...rest}>
            {children}
        </div>
    );
};

export const AppStripeTableHead = ({children, ...rest}: PropsWithChildren) => {
    return (
        <div className='app-stripe-table__head' {...rest}>
            {children}
        </div>
    );
};

interface AppStripeTableRowProps {
    className?: string;
    children: ReactNode;
}
export const AppStripeTableRow = ({children, className}: AppStripeTableRowProps) => {
    const classNames = `app-stripe-table__row ${className || ''}`.trim();

    return <div className={classNames}>{children}</div>;
};

interface AppStripeTableCellProps {
    className?: string;
    children: ReactNode;
}
export const AppStripeTableCell = ({children, className}: AppStripeTableCellProps) => {
    const classNames = `app-stripe-table__cell ${className || ''}`.trim();

    return <div className={classNames}>{children}</div>;
};
